import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import cn from 'classnames';

import { lodashGet } from 'functions/lodashGet';
import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import styles from './AgreementsSupportingDocumentsAttachment.module.scss';

interface IAgreementsSupportingDocumentsAttachmentProps {
  watchOnly: boolean;
  name: string;
  acceptedFiles: string;
  formRef?: IKnmFormRef | IDecisionFormRef;
  title: JSX.Element | string;
  hideButtonAdd?: boolean;
  id?: string;
  margin?: string;
  isRequired?: boolean;
  type?: 'one';
}

export const AgreementsSupportingDocumentsAttachment = memo(
  ({
    id,
    watchOnly,
    name,
    formRef,
    title,
    hideButtonAdd,
    acceptedFiles,
    margin,
    isRequired,
    type,
  }: IAgreementsSupportingDocumentsAttachmentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    const wrapperAttributes = {
      ...(margin === 'none' && { 'data-margin-none': true }),
    };

    return (
      <div
        className={cn({
          [styles.ActDocumentOne]: type === 'one',
          [styles.ActDocument]: type !== 'one',
        })}
        {...wrapperAttributes}
      >
        <FieldBlock
          id={id}
          label={title}
          color="black"
          type="not-space"
          button={
            !hideButtonAdd &&
            type !== 'one' && (
              <Button
                className={'shared-btn-add'}
                text="Добавить"
                variant="link"
                color="primary"
                type="button"
                id="fileAddButton"
                disabled={watchOnly}
                onClick={openSignModal}
              />
            )
          }
        />
        {isRequired && (
          <FormSpy subscription={{ errors: true, touched: true }}>
            {props => {
              const fieldError = lodashGet(props.errors, name);
              const errorMessage: string | undefined = fieldError
                ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
                : undefined;

              if (errorMessage && props.touched?.[name]) {
                return (
                  <p className={`shared-input-error shared-row__small-margin ${styles.AttachmentErrorText}`}>
                    {errorMessage}
                  </p>
                );
              }

              return null;
            }}
          </FormSpy>
        )}
        {!hideButtonAdd && type === 'one' && (
          <div>
            <Button
              className={'shared-btn-add'}
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              disabled={watchOnly}
              onClick={openSignModal}
            />
          </div>
        )}
        <KnmAttachmentsSigning
          acceptedFiles={acceptedFiles}
          isWatchOnly={watchOnly}
          name={name}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
      </div>
    );
  },
);
